The information required to post a job ad for a newly created position.
